import type { ReactNode } from 'react'
import { Suspense } from 'react'
import { LoadErrorBoundary } from './LoadErrorBoundary'

export const LoadEmpty = (p: { readonly children?: ReactNode }) => (
	<LoadErrorBoundary>
		<Suspense fallback={null}>{p.children}</Suspense>
	</LoadErrorBoundary>
)
